import axios from 'axios';
import router from './router';
import {toast} from "vue3-toastify";

const http = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_API_URL,
});

http.interceptors.request.use(config => {
    // Извлекаем токен из localStorage
    const token = localStorage.getItem('auth-token');
    if (token) {
        // Если токен существует, добавляем его в заголовки каждого запроса
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    // Пробрасываем ошибку дальше, если что-то пошло не так
    return Promise.reject(error);
});

// добавляем интерсептор ответов для обработки общих случаев ответов
http.interceptors.response.use(response => {
    // Просто возвращаем ответ, если все в порядке
    return response;
}, error => {
    // Обрабатываем ошибки, например, если срок действия токена истек
    if (error.response) {
        toast.error(error.response.data.message, {
            autoClose: 3000,
        });
        if (error.response.status === 401) {
            // Можно реализовать логику перенаправления на страницу логина, обновления токена и т.д.
            if (error.response.data && error.response.data.message === 'Invalid credentials.') {
                console.log('Invalid credentials');
            } else {
                console.log('Необходима аутентификация. Перенаправление на страницу входа.');
                setTimeout(() => {
                    // Очистка токена из localStorage
                    localStorage.removeItem('auth-token');
                    router.push('/login');
                }, 3000);
            }
        }
    }
    return Promise.reject(error);
});

export default http;
